<template>
  <customModal :containerxxl="true" @closeModal="closeAssignModal()">
    <template #title>
      SoA Extraction
    </template>
    <template #body>
  <div class="wrapper wrapper-content animated fadeInRight px-0 pt-0">
    <div style="height: 70vh">
      <div class="row h-100">
        <div class="col-12 col-md-4 ibox-content">
          <div>
             <label class="mb-0" for="inputProtocol">{{$t('navigations.browse protocol')}}</label>
            <div class="input-group">            
              <input
                ref="inputProtocol"
                accept=".pdf"
                id="inputProtocol"
                type="file"
                class="form-control my-2 my-lg-0"
                @change="previewFiles($event)"
                :disabled="showLoading"
              />
              <span class="input-group-append">
                <button
                  type="button"
                  class="btn btn-sm btn-primary py-0 position-relative"
                  @click="protocolExport()"
                  :disabled="showLoading"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': showLoading == false,
                      'opacity-1': showLoading == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <div
                    :class="{
                      'opacity-1': showLoading == false,
                      'opacity-0': showLoading == true,
                    }"
                  >
                    {{ $t("navigations.upload") }}
                  </div>
                </button>
              </span>
             
            </div>
            <div>
            <div class="error-file-block d-flex align-items-center" v-if="showValidation==true">
              <div class="error-icon"> <i class="fa fa-warning"></i></div>            
              <p class="mb-0">{{$t('navigations.please select a file')}}</p>
            </div>
            </div>
           
              <!-- Supported format & download template link -->
            <div class="alert-light d-flex justify-content-between mb-2">
              <small><strong>{{$t('navigations.supported format')}}&nbsp;:</strong> .pdf</small>
            </div>
          </div>
         <!-- <div>
          <div class="mb-1">Orientation</div>
            <label>
              <input type="radio" name="orientation" :value="false" v-model="isLandscape">
              Portrait
            </label>
            <label class="ml-2">
              <input type="radio" name="orientation" :value="true" v-model="isLandscape">
              Landscape
            </label>
          </div> -->
          <div v-if="showProtocolExtractionActions" class="protocol-import-actions mt-3 pt-2">
            <small class="d-block text-muted mb-2">
              Protocol import completed. Select one or more extraction actions.
            </small>
            <div class="protocol-action-controls">
              <div class="protocol-action-buttons">
                <button
                  v-for="action in protocolExtractionActions"
                  :key="action"
                  class="btn btn-sm protocol-action-btn py-0"
                  :class="{ 'protocol-action-btn--active': selectedProtocolExtractionActions.includes(action) }"
                  type="button"
                  :aria-pressed="selectedProtocolExtractionActions.includes(action)"
                  :disabled="protocolActionLoading !== ''"
                  @click="toggleProtocolExtractionAction(action)"
                >
                  {{ action }}
                </button>
              </div>              
            </div>
            <div class="mt-2 d-flex justify-content-end mr-2">
              <button
                class="btn btn-sm btn-primary protocol-action-ok-btn"
                type="button"
                :disabled="protocolActionLoading !== '' || selectedProtocolExtractionActions.length === 0"
                @click="handleProtocolExtractionAction()"
              >
                {{ protocolActionLoading !== '' ? 'Running...' : 'Extract' }}
              </button>           
            </div>
            <div class="mt-2">
            <p
              v-if="protocolActionStatusMessage"
              class="protocol-action-status mb-0 mt-2"
              :class="{
                'protocol-action-status--info': protocolActionStatusType === 'info',
                'protocol-action-status--success': protocolActionStatusType === 'success',
                'protocol-action-status--error': protocolActionStatusType === 'error'
              }"
            >
              {{ protocolActionStatusMessage }}
            </p>
            </div>
          </div>
</div>
        <div class="col-12 col-md-8 ibox-content">
          <div v-if="readyToView==false" class="d-flex justify-content-center align-items-center h-100">
            <div class="text-center">
              <img class="mb-2" src="../../assets/img/EmptyFile.svg" alt="Add a file" width="50"
                 />
              <h4>{{$t('navigations.please upload a protocol to view here')}}</h4>
            </div>
           
          </div>
          <div v-else class="pdfembeded">
            <vue-pdf-embed :source="source" />
          </div>
      </div>
      </div>
    </div>
  </div>
  </template>
  </customModal>
</template>
<script src="./ImportProtocol.js"></script>
<style scoped>
.dots::after {
  content: '.....';
  letter-spacing: 3px;
  animation: fadeDots 1.5s infinite;
}
 
@keyframes fadeDots {
  0%   { opacity: 0; }
  20%  { opacity: 0.2; }
  40%  { opacity: 0.4; }
  60%  { opacity: 0.6; }
  80%  { opacity: 0.8; }
  100% { opacity: 1; }
}
.view-link{
   color: hsl(211, 100%, 50%);
}
.info-icon {
  color: hsl(211, 100%, 50%);
  font-size: 1rem;
  margin-right: 10px;
  line-height: 1.2;
}
 
.info-block{
  background: hsl(212, 100%, 97%);
  border: 1px solid #cce5ff;
  border-left: 3px solid #007bff;
  border-radius: 8px;
  padding: 6px 10px;
}
.error-icon {
  color: hsl(4, 100%, 50%);
  font-size: 1rem;
  margin-right: 10px;
  line-height: 1.2;
}
 
.error-file-block{
  background: hsl(0deg 100% 92.06%);
  border: 1px solid #cce5ff;
  border-left: 3px solid #ff1100;
  border-radius: 8px;
  padding: 6px 10px;
}
.opacity-0 {
  opacity: 0;
}
 
.opacity-1 {
  opacity: 1;
}
.import-box {
  border: 2px dashed #618bd7;
  border-radius: 5px;
  padding: 2rem 1rem;
  text-align: center;
  background: #f7fafd;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  position: relative;
}
.import-box--active {
  border-color: #3867d6;
  background: #eaf1ff;
}
.protocol-import-actions {
  border-top: 1px solid #e7eaec;
}
.protocol-action-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.protocol-action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.protocol-action-btn {
  min-width: 73px;
  border: 1px solid #1a6fc4;
  background: #fff;
  color: #1a6fc4;
}
.protocol-action-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.protocol-action-btn:hover,
.protocol-action-btn:focus {
  border-color: #145faf;
  background: #eef5ff;
  color: #145faf;
}
.protocol-action-btn--active,
.protocol-action-btn--active:hover,
.protocol-action-btn--active:focus {
  background: #1a6fc4;
  border-color: #1a6fc4;
  color: #fff;
}
.protocol-action-ok-btn {
  min-width: 64px;
}
.protocol-action-status {
  font-size: 0.875rem;
}
.protocol-action-status--info {
  color: #1d4ed8;
}
.protocol-action-status--success {
  color: #198754;
}
.protocol-action-status--error {
  color: #dc3545;
}
.soa-page-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.soa-page-action-btn {
  min-width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: .1rem !important;
}
</style>
